import { render, staticRenderFns } from "./SearchButtons.vue?vue&type=template&id=77c7c6e4&scoped=true"
import script from "./SearchButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchButtons.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7c6e4",
  null
  
)

export default component.exports